export default "__VITE_ASSET__f1cd37e5__"